import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-rescheduling-modal',
  templateUrl: './rescheduling-modal.component.html',
  styleUrls: ['./rescheduling-modal.component.scss']
})
export class ReschedulingModalComponent implements OnInit {

  hasErrorReason: boolean = false;
  typeSurvey: any;
  rescheduleCount: number = 0;
  profile: string = '';
  selectedNewSurveyType: any;
  enableButton: boolean = false;
  isExternalAccess: boolean = false;

  form = this.fb.group({
    cancelReasons: [null]

  });

  constructor(
    private dialogRef: MatDialogRef<ReschedulingModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
     this.typeSurvey = this.data.typeSurvey;
     this.rescheduleCount = this.data.rescheduleCount;
     this.profile = this.data.externalAccess ? 'Usuario Externo' : this.data.profile;
     this.setNewSurveyType()
  }

  selectSurveyType(event) {
    this.enableButton = true;
    this.selectedNewSurveyType = event.target.value;
  }

  setNewSurveyType() {
    if (this.profile !== 'Master' && this.profile !== 'Master Cliente') {
      if ((this.data.typeSurvey === 'VISTORIA ACOMPANHADA' || this.data.typeSurvey === 'TRADICIONAL')) {
        this.enableButton = true;
        this.selectedNewSurveyType = '3';
      }
    }
  }

  submit(){
    if (this.form.controls['cancelReasons'].value == null && this.data.cancelReasons?.length > 0) {
      this.hasErrorReason = true;
      return;
    }
    let resultChoose = {
      reasonId: this.form.controls['cancelReasons'].value,
      choose: true,
      newSurveyType: this.selectedNewSurveyType
    }
    this.dialogRef.close(resultChoose);
  }

  cancel(){
    let resultChoose = {
      reasonId: "",
      choose: false,
      newSurveyType: null
    }
    this.dialogRef.close(resultChoose);
  }
}
